import type { ConceptDef } from '../types';

export const sortByFeature: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-by-feature',
  label: 'Sort by Feature',
  category: 'Sorting',
  description: 'Hear a feature; tap an item that has it.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'has wheels', answer: '🚗 car' },
      { say: 'has wings', answer: '🐦 bird' },
      { say: 'has legs', answer: '🪑 chair' },
      { say: 'is round', answer: '⚽ ball' },
      { say: 'has petals', answer: '🌹 rose' },
    ],
  },
};
